import { ColliTypeSelect } from '@frontend/colli/select';
import { ColliType } from '@frontend/colli/types';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useColliTypeConstraintDataInput from './colli-type-constraint-data-input.controller';

const ID = 'colli-type-constraint-data-input';

export interface ColliTypeConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const ColliTypeConstraintDataInput = (props: ColliTypeConstraintDataInputProps) => {
    const viewProps = useColliTypeConstraintDataInput(props);

    return (
        <ColliTypeSelect
            id={ID}
            required
            value={viewProps.formValues?.type as ColliType ?? null}
            onSelect={(v) => {
                props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { type: v.value } : undefined }));
            }}
        />
    );
};

export default ColliTypeConstraintDataInput;
